import { Navigate, useSearchParams } from "react-router"
import AddMedicationStep from "./steps/AddMedicationStep"
import MedicationQuestionStep from "./steps/MedicationQuestionStep"
import MedicationRemindersStep from "./steps/MedicationRemindersStep"
import ShippingStep from "./steps/ShippingStep"
import WelcomeStep from "./steps/WelcomeStep"

const ONBOARDING_STEPS = [
  "welcome",
  "shipping",
  "medication-question",
  "add-medication",
  "medication-reminders",
] as const
type OnboardingStep = (typeof ONBOARDING_STEPS)[number]

const isValidStep = (value: string | null): value is OnboardingStep =>
  ONBOARDING_STEPS.includes(value as OnboardingStep)

const OnboardingPage = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const stepParam = searchParams.get("step")

  if (!isValidStep(stepParam)) {
    return <Navigate to="/onboarding?step=welcome" replace />
  }

  const step = stepParam

  const goToStep = (next: OnboardingStep) => setSearchParams({ step: next })

  switch (step) {
    case "welcome":
      return <WelcomeStep onNext={() => goToStep("shipping")} />
    case "shipping":
      return <ShippingStep onNext={() => goToStep("medication-question")} />
    case "medication-question":
      return <MedicationQuestionStep onNext={() => goToStep("add-medication")} />
    case "add-medication":
      return <AddMedicationStep onNext={() => goToStep("medication-reminders")} />
    case "medication-reminders":
      return <MedicationRemindersStep />
  }
}

export default OnboardingPage
